import { Component, inject, input, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
  LucideApple,
  LucideBookOpen,
  LucideCalendar,
  LucideClipboardList,
  LucideFileText,
  LucideFlaskConical,
  LucideGrid3X3,
  LucideHouse,
  LucideLayoutList,
  LucideListChecks,
  LucideMail,
  LucidePill,
  LucidePlus,
  LucideRuler,
  LucideSettings,
} from '@lucide/angular';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TranslatePipe } from '../../i18n/translate.pipe';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-side-menu',
  imports: [
    RouterLink,
    NzMenuModule,
    NzTooltipModule,
    TranslatePipe,
    LucideHouse,
    LucideLayoutList,
    LucideListChecks,
    LucidePlus,
    LucideFileText,
    LucideCalendar,
    LucideClipboardList,
    LucideApple,
    LucideRuler,
    LucideGrid3X3,
    LucideFlaskConical,
    LucideBookOpen,
    LucideMail,
    LucidePill,
    LucideSettings,
  ],
  templateUrl: './side-menu.html',
  styleUrl: './side-menu.scss',
})
export class SideMenu {
  private readonly router = inject(Router);

  // El padre (App) controla si el sider esta colapsado.
  // Cuando esta colapsado, el menu inline muestra solo iconos + tooltip
  // automaticamente. NG-ZORRO se encarga de la animacion.
  readonly collapsed = input<boolean>(false);
  readonly isAdmin = input<boolean>(false);

  /** Solo controla si aparece la entrada de menú de allowlist de registro (feature de staging). */
  protected readonly isStaging = environment.isStaging;

  // Solo un submenu de primer nivel permanece abierto a la vez (modo acordeon).
  protected readonly openSubmenuKey = signal<string | null>(null);

  protected onSubmenuOpenChange(key: string, isOpen: boolean): void {
    if (isOpen) {
      this.openSubmenuKey.set(key);
    } else if (this.openSubmenuKey() === key) {
      this.openSubmenuKey.set(null);
    }
  }

  protected isAdminFoodsMenuActive(): boolean {
    const url = this.router.url;
    if (url.includes('/foods/group-review')) {
      return false;
    }

    return url.startsWith('/admin/system/foods');
  }

  protected isGroupReviewMenuActive(): boolean {
    return this.router.url.startsWith('/admin/system/foods/group-review');
  }
}
